import { getRoutes } from '@ui-framework/index';
import {
  authFnAllowOnlySAWithModule,
  ModuleSettingsAuthorizationWrapper,
} from '@product-framework/components/AuthorizationWrapper';
import ServiceDirectory from './pages/map/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';
import ServiceDirectoryFormStore from './store/index';

const Pages = ProtectedRoute => ({
  ServiceDirectory: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceDirectory}
      AuthorizationWrapper={ModuleSettingsAuthorizationWrapper}
      AuthorizationWrapperProps={{
        moduleName: 'serviceDirectoryPurchased',
        authorizationFn: [authFnAllowOnlySAWithModule],
      }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    serviceDirectoryFormStore: new ServiceDirectoryFormStore(rootStore),
  },
];

export { ServiceDirectory, routes, stores };
